import { FunctionComponent } from 'react';
import DashboardLayout from '../../components/layout/layout';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import ManageChannelPartnersIcon from '../../assets/img/Manage Channel Partners.png';
import ManagerCustomerIcon from '../../assets/img/Manage Customers.png'
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { useNavigate } from 'react-router-dom';
import { styled } from "@mui/material/styles";

const ActionCard = styled(Paper)(({ theme }) => ({
  width: 180,
  height: 100,
  backgroundColor: '#f2f2f2',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '2px 2px 4px rgba(0,0,0,0.2)',
  borderRadius: 4,
  cursor: 'pointer',
  textAlign: 'center'
}));

const BarksdaleAdminDashboard: FunctionComponent = () => {
  const navigate = useNavigate();
  
  const buttons = [
    { label: 'Manage Channel Partners', disabled: false, icon: <img src={ManageChannelPartnersIcon} alt="Manage Channel Partners" style={{ width: 40, height: 40 }} />, navigateTo: '/otherextranet/managecp' },
    { label: 'Manage Customers', disabled: true, icon: <img src={ManagerCustomerIcon} alt="Manage Customers" style={{ width: 40, height: 40 }} />, navigateTo: '/customer/custdashboard' },
  ];

  return (
    <>
      <DashboardLayout titleIcon={<DesktopWindowsOutlinedIcon />} title={"Barksdale Admin"} initialBreadcrumbs={"Barksdale Admin"} levelBreadcrumbs={"Extranet"} breadcrumbs={''} activeMenu={'overview'} showSupport={false} containerTitle={"Barksdale Administrator"}>
        <Box sx={{ width: '100%', maxWidth: '100%' }}>
          <Grid container spacing={5}
            sx={{
              display: 'flex',
              justifyContent: 'normal',
              alignItems: 'center',
              maxWidth: '100%',
            }}
          >
            {buttons.map((btn, index) => (
              <Grid key={index}>
                <ActionCard 
                  onClick={btn.disabled ? undefined : () => navigate(btn.navigateTo)}
                  sx={{ 
                    border: '1px solid #e1e1e1', 
                    boxShadow: btn.disabled 
                      ? 'none' 
                      : `inset 0 0 10px rgba(0, 0, 0, 0.1), inset 0 0 5px rgba(255, 255, 255, 0.6)`,
                    opacity: btn.disabled ? 0.5 : 1,
                    cursor: btn.disabled ? 'not-allowed' : 'pointer',
                    backgroundColor: btn.disabled ? '#f8f8f8' : '#f2f2f2',
                    '&:hover': {
                      backgroundColor: btn.disabled ? '#f8f8f8' : '#e8e8e8',
                      transform: btn.disabled ? 'none' : 'scale(1.02)',
                    },
                    transition: 'all 0.2s ease-in-out',
                  }}
                >
                  <Box position="relative">
                    {btn.icon}
                  </Box>
                  <Typography 
                    variant="body2" 
                    fontWeight="bold" 
                    sx={{ 
                      width: '65%',
                      color: btn.disabled ? '#999' : '#000',
                    }}
                  >
                    {btn.label}
                  </Typography>

                </ActionCard>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ mt: 3, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Button variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '110px' }} onClick={() => navigate(-1)}>
              BACK
            </Button>
          </Box>
        </Box>
      </DashboardLayout>
    </>
  );
};

export default BarksdaleAdminDashboard;
